<template>
  <div>
    <div
      ref="articleFrame"
      class="w-100 border-0 d-block iFrameWrapper"
      v-html="frameHtml ?? ''"
    ></div>
  </div>
  <Teleport v-if="repData && repSignatureTarget" :to="repSignatureTarget">
    <AgentDetailsLeadGen :agent-data-retreived="repData"></AgentDetailsLeadGen>
  </Teleport>
</template>
<script lang="ts">
import { defineComponent, nextTick, type PropType } from 'vue';
import type { RouteQueryParams } from '@/interfaces/SocialFormProps';
import AgentDetailsLeadGen from '@/components/AgentDetailsLeadGen.vue';
import type { LeadGenAgentDetails } from '@/interfaces/PegaAgent';
import PegaApiStore from '@/stores/pegaApi.store';

export default defineComponent({
  components: {
    AgentDetailsLeadGen,
  },
  props: {
    frameHtml: {
      type: String as PropType<string | null>,
      required: true,
    },
    params: {
      type: Object as PropType<RouteQueryParams>,
      required: true,
    },
    repData: {
      type: Object as PropType<LeadGenAgentDetails | null>,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      pegaStore: PegaApiStore(),
      repSignatureTarget: null as HTMLElement | null,
      articleFrame: null as HTMLDivElement | null,
    };
  },
  mounted() {
    this.articleFrame = this.$refs.articleFrame as HTMLDivElement;
    void this.processInjectedContent();
  },
  computed: {
    signaturePlaceHolderExists(): boolean | undefined {
      return this.frameHtml?.includes('RepSignaturePlaceholder');
    },
    mashupContainerExists(): boolean | undefined {
      return this.frameHtml?.includes('ContactFormPlaceholder');
    },
  },
  watch: {
    frameHtml() {
      void this.$nextTick(() => this.processInjectedContent());
    },
  },
  methods: {
    async processInjectedContent() {
      await nextTick();
      if (!this.articleFrame) return;

      this.repSignatureTarget = this.articleFrame.querySelector('#RepSignaturePlaceholder');
      const mashupContainer = this.articleFrame.querySelector('#ContactFormPlaceholder');
      if (mashupContainer) {
        this.pegaStore.handlePegaMashup(mashupContainer as HTMLDivElement, this.params);
      }
    },
  },
});
</script>
<style>
.iFrameWrapper .u-row-container:nth-of-type(3) table td {
  padding: 0 !important;
}
</style>
